import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import './css/App.css';

import { MerchoidSalesDashboard } from './components/NewPricing/MerchoidSalesDashboard/MerchoidSalesDashboard';
import { SingleProductCalculator } from './components/NewPricing/SingleProductCalculator/SingleProductCalculator';
import { BulkProductCalculator } from './components/NewPricing/BulkProductCalculator/BulkProductCalculator';
import { CheckActualShippingCosts } from './components/NewPricing/CheckActualShippingCosts/CheckActualShippingCosts';
import { ExchangeRates } from './components/NewPricing/ExchangeRates/ExchangeRates'
import { ZeroCostProduct } from './components/NewPricing/ZeroCostProduct/ZeroCostProduct';
import { GroupedShippingPrices } from './components/NewPricing/GroupedShippingPrices.js/GroupedShippingPrices.js';
import { BulkUploadStdPricing } from './components/NewPricing/BulkUploadStdPricing/BulkUploadStdPricing';
import { Packaging } from './components/NewPricing/Packaging/Packaging'
import { AmazonPriceSetter } from './components/AmazonPriceSetter/AmazonPriceSetter'
import { AmazonDailySales } from './components/AmazonDailySales/AmazonDailySales'
import { AmazonInventory } from './components/AmazonInventory/AmazonInventory'
import { BulkUpdateZeroCost } from './components/BulkUpdateZeroCost/BulkUpdateZeroCost';
import { AddUpdateProducts } from './components/NewPricing/Reports/AddUpdateProducts/AddUpdateProducts';
import { TagProducts } from './components/NewPricing/Reports/TagProducts/TagProducts';
import { StockValueGraph } from './components/NewPricing/Reports/StockValueGraph/StockValueGraph';
import { StockValueTable } from './components/NewPricing/Reports/StockValueTable/StockValueTable';
import { StockSalesGraph } from './components/NewPricing/Reports/StockSalesGraph/StockSalesGraph'


export default class App extends React.Component {
  render() {
    return (
      <Router basename='/kylokenobiswiftreact/'>
        <div>
          <Navbar bg="primary" expand="lg" variant="dark">
            <Container>
              <Navbar.Brand href="/">Merchoid Tools</Navbar.Brand>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto">

                  <NavDropdown title="Merchoid" id="basic-nav-dropdown">
                    <NavDropdown.Item href="/kylokenobiswiftreact/MerchoidSalesDashboard">Sales Dashboard</NavDropdown.Item>
                    <NavDropdown.Item href="/kylokenobiswiftreact/SingleProductCalculator">Single Product Calculator</NavDropdown.Item>
                    <NavDropdown.Item href="/kylokenobiswiftreact/BulkProductCalculator">Bulk Product Calculator</NavDropdown.Item>
                    <NavDropdown.Item href="/kylokenobiswiftreact/ZeroCostProducts">Zero Cost Products</NavDropdown.Item>
                    <NavDropdown.Item href="/kylokenobiswiftreact/BulkUpdateZeroCost">Bulk Update Zero Cost Products</NavDropdown.Item>
                    <NavDropdown.Item href="/kylokenobiswiftreact/CheckActualShippingCosts">Check Actual Shipping Costs</NavDropdown.Item>
                  </NavDropdown>
                  <NavDropdown title="Amazon" id="basic-nav-dropdown">
                    <NavDropdown.Item href="/kylokenobiswiftreact/AmazonPriceSetter">Add/Update Amazon Stock</NavDropdown.Item>
                    <NavDropdown.Item href="/kylokenobiswiftreact/AmazonInventory">View Amazon Inventory</NavDropdown.Item>
                    <NavDropdown.Item href="/kylokenobiswiftreact/GroupedShippingPrices">Amazon Daily Sales Calculator</NavDropdown.Item>
                  </NavDropdown>
                  <NavDropdown title="Packaging" id="basic-nav-dropdown">
                    <NavDropdown.Item href="/kylokenobiswiftreact/Packaging">View/edit Packaging</NavDropdown.Item>
                  </NavDropdown>
                  <NavDropdown title="Reports" id="basic-nav-dropdown">
                    <NavDropdown.Item href="/kylokenobiswiftreact/AddUpdateProducts">Add/Update Products</NavDropdown.Item>
                    <NavDropdown.Item href="/kylokenobiswiftreact/TagProducts">Tag Products</NavDropdown.Item>
                    <NavDropdown.Item href="/kylokenobiswiftreact/StockValueGraph">Stock Value Graph</NavDropdown.Item>
                    <NavDropdown.Item href="/kylokenobiswiftreact/StockValueTable">Stock Value Table</NavDropdown.Item>
                    <NavDropdown.Item href="/kylokenobiswiftreact/StockSalesGraph">Stock Sales Graph</NavDropdown.Item>
                    <NavDropdown.Item href="/kylokenobiswiftreact/StockSalesTimeGraph">Stock Sales Time Graph</NavDropdown.Item>

                  </NavDropdown>
                  <NavDropdown title="Admin" id="basic-nav-dropdown">
                    <NavDropdown.Item href="/kylokenobiswiftreact/ExchangeRates">Update Exchange Rates</NavDropdown.Item>
                    <NavDropdown.Item href="/kylokenobiswiftreact/GroupedShippingPrices">Edit Grouped Shipping Weightings</NavDropdown.Item>
                    <NavDropdown.Item href="/kylokenobiswiftreact/BulkUploadStdPricing">Bulk Update Shipping Prices</NavDropdown.Item>
                  </NavDropdown>

                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>


          <Switch>
            <Route path="/MerchoidSalesDashboard">
              <MerchoidSalesDashboard />
            </Route>
            <Route path="/SingleProductCalculator">
              <SingleProductCalculator />
            </Route>
            <Route path="/BulkProductCalculator">
              <BulkProductCalculator />
            </Route>
            <Route path="/ZeroCostProducts/">
              <ZeroCostProduct />
            </Route>
            <Route path="/CheckActualShippingCosts">
              <CheckActualShippingCosts />
            </Route>
            <Route path="/ExchangeRates">
              <ExchangeRates />
            </Route>
            <Route path="/GroupedShippingPrices">
              <GroupedShippingPrices />
            </Route>
            <Route path="/BulkUploadStdPricing">
              <BulkUploadStdPricing />
            </Route>
            <Route path="/Packaging">
              <Packaging />
            </Route>
            <Route path='/AmazonPriceSetter'>
              <AmazonPriceSetter />
            </Route>
            <Route path='/AmazonInventory'>
              <AmazonInventory />
            </Route>
            <Route path='/AmazonDailySales'>
              <AmazonDailySales />
            </Route>
            <Route path='/BulkUpdateZeroCost'>
              <BulkUpdateZeroCost />
            </Route>
            <Route path='/AddUpdateProducts'>
              <AddUpdateProducts />
            </Route>
            <Route path='/TagProducts'>
              <TagProducts />
            </Route>
            <Route path='/StockValueGraph'>
              <StockValueGraph />
            </Route>
            <Route path='/StockValueTable'>
              <StockValueTable />
            </Route>
            <Route path='/StockSalesGraph'>
              <StockSalesGraph
                stockSalesGraph={true} />
            </Route>
            <Route path='/StockSalesTimeGraph'>
              <StockSalesGraph
                stockSalesTimeGraph={true} />
            </Route>



          </Switch>





          {/* 
          <nav>
           
            <div className='link'>
              <Link to='/SingleProduct'>Single Product Pricing</Link>
            </div>
            <div className='link'>
              <Link to='/CheckMargin'>Check Margin by price</Link>
            </div>
            <div className='link'>
              <Link to='/UkBatchProductPricing'>Batch Product Pricing</Link>
            </div>
            <div className='link'>
              <Link to='/PriceUpdateFormatter'>Bulk Price Update Formatter</Link>
            </div>
            <div className='link'>
              <Link to='/DailySales'>Margin Analysis</Link>
            </div>
            <div className='link'>
              <Link to='/AmazonPriceSetter'>Amazon Price Setter</Link>
            </div>
            <div className='link'>
              <Link to='/getAmazonInventory'>Amazon Stock</Link>
            </div>
            <div className='link'>
              <Link to='/AmazonDailySales'>Daily Amazon Sales</Link>
            </div>
            <div className='link'>
              <Link to='/PostageCalculator'>Postage Calculator</Link>
            </div>
            <div className='link'>
              <Link to='newPricing'>New Pricing</Link>
            </div>
          </nav>

          {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. 
          <Switch>
            <Route path='/PostageCalculator'>
              <PostageCalculator />
            </Route>
            <Route path='/SingleProduct'>
              <TargetMargins singleProduct={true} />
            </Route>
            <Route path='/CheckMargin'>
              <CheckMargin />
            </Route>
            <Route path='/UkBatchProductPricing'>
              <TargetMargins UkBatchProductPricing={true} />
            </Route>
            <Route path='/DailySales'>
              <TargetMargins DailySales={true} />
            </Route>
            <Route path='/AmazonPriceSetter'>
              <AmazonPriceSetter />
            </Route>
            <Route path='/getAmazonInventory'>
              <AmazonInventory />
            </Route>
            <Route path='/AmazonDailySales'>
              <AmazonDailySales />
            </Route>
            <Route path='/PriceUpdateFormatter'>
              <PriceUpdateFormatter />
            </Route>
            <Route patch='/NewPricing'>
              <NewPricing />
            </Route>
     

          </Switch>*/}
        </div>
      </Router>
    );
  }
}
